import o from "./index82.mjs";
import i from "./index104.mjs";
function f(t) {
  var r = i(t, "string");
  return o(r) == "symbol" ? r : r + "";
}
export {
  f as default
};
